var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.notices.length)?_c('div',{staticClass:"container my-6"},_vm._l((_vm.notices),function(notice,index){return _c('project-notice-item',{key:index,attrs:{"notice":notice}})}),1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }